// x, y: location
// w: width, height: height

import { ICheckItem, IForm, IProgram } from '../interfaces/interfaces';

// isStatic : fix location or not
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function simpleLayout(i: string, x: number, y: number, w: number, h: number, isStatic: boolean) {
  return {
    i: `${i}-${Math.round(Math.random() * 10000)}`,
    x, // column, start from 0
    y, // row, start from 0
    w, // width of the component
    h, // height of the component
    static: isStatic,
    maxW: 2,
    maxH: 2,
    isResizable: false,
  };
}

// USER DATA

// PP_Cockpit (http://localhost:3000/partnerportal-cockpit)
export const pcMockDataUnauthenticated = {
  user: null,
  tiles: [
    {
      id: '1',
      module: 'SearchModule',
      props: {},
      layout: simpleLayout('SearchModule', 0, 0, 3, 1, true),
      tileRefId: '1',
    },

    {
      id: '2',
      module: 'RegistrationModule',
      layout: simpleLayout('m023', 0, 1, 3, 1, true),
      props: {},
      tileRefId: '5120',
    },
    {
      id: '3',
      module: 'LinkedIconModule',
      layout: simpleLayout('LinkedIconModule', 3, 0, 1, 1, false),
      props: {
        headline: 'Dokumentarchiv',
        linkText: 'Dokumentenarchiv Link',
        linkHref:
          'https://kfw-dev1.test-server.ag/partner/Technische-Seiten/Authentifizierung/index.jsp?vsp_referrer=%2fpartner%2fPartner-der-KfW%2fDokumentenarchiv%2fDokumentenarchiv-haupia.jsp',
        linkTarget: '_blank',
        locked: true,
      },
    },
  ],
};

// PP_Cockpit(Wiht user) (http://localhost:3000/partnerportal-cockpit--loggedin)
export const pcMockDataAuthenticated = {
  user: {
    username: 'KfW Kurt',
  },
  tiles: [
    {
      id: '1',
      module: 'AdvantageCommunicationModule',
      layout: simpleLayout('personalisation', 0, 0, 2, 1, true),
      tileRefId: '1',
      props: {
        headline: '1 Personalisieren Sie Ihr Cockpit',
        personalisationLink: '#',
        personalisationText: 'Personalisierung starten',
        advantageList:
          '<li>Ipsam dit aceaquid eum qui sit accaest.</li><li>Faceped experep eriatiaes nobi et Tempor</li><li>Beaquas del endis placias natquam molupid</li>',
      },
    },

    {
      id: '2',
      module: 'SearchModule',
      tileRefId: '2',
      layout: simpleLayout('SearchModule', 0, 1, 3, 1, true),
      props: {
        headline: '4 Was suchen Sie im Partnerportal?',
        textContent:
          'Lorem Ipsum 1x1 Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
        searchActionUrl: 'https://kfw-dev1.test-server.ag/mediamaster/DEV/haupia/Suchseiten-mit-neuem-HTML/index.jsp',
        searchParams: [
          { key: 'facetFilterSubjectKey', value: '1' },
          { key: 'facetFilterSubjectValue', value: 'general:6_28801/' },
        ],
      },
    },

    {
      id: '4',
      module: 'ProductModule',
      tileRefId: '3',
      layout: simpleLayout('ProductModule1', 3, 1, 1, 1, false),
      props: {
        headline: '5 Kredit (m001 1x1)',
        creditId: '076-077B',
        textContent: 'Altersgerecht Umbauen - Kredit',
        linkText: 'Zum Kredit',
        linkHref: '',
      },
    },

    {
      id: '5',
      module: 'ProductModule',
      tileRefId: '2',
      layout: simpleLayout('ProductModule2', 0, 2, 1, 1, false),
      props: {
        headline: '6 Zuschuss (m002 1x1)',
        creditId: '420',
        textContent: 'Lorem Ipsum',
        linkText: 'Zum Zuschuss',
        linkHref: '',
        linkTarget: '',
      },
    },
    {
      id: '6',
      module: 'LinkedIconModule',
      tileRefId: '5187',
      layout: simpleLayout('LinkedIconModule', 1, 2, 1, 1, false),
      props: {
        headline: '7 Alle Kontakte',
        linkText: 'Zur Kontaktliste',
        linkHref: '',
        linkTarget: '',
        dataOverlayUrl: 'https://kfw-dev1.test-server.ag/inlandsfoerderung/Tools/Schnipsel/vc_overlay_1472.html',
        dataOverlaySize: 'large',
        dataIsAjax: true,
        dataOverlayBind: false,
        locked: false,
      },
    },
    {
      id: '7',
      module: 'PersonalizationModule',
      tileRefId: '2',
      layout: simpleLayout('PersonalizationModule', 2, 0, 1, 1, true),
      props: {
        headline: '2 Cockpit personalisieren',
      },
    },
    {
      id: '8',
      module: 'InfocenterModule',
      layout: simpleLayout('InfocenterModule', 3, 2, 1, 1, false),
      props: {
        headline: '8 Service/Infocenter (m007 1x1)',
        textContent: 'Finanzierungspartner und Unternehmen für eine tolle Zusammenarbeit',
        phone: '0800 539 9002',
        phoneHref: '08005399002',
        phoneAriaLabel: '0 8 0. 5 3 9. 9 0 0 2',
        noticeCost: 'Kostenfreie Servicenummer*',
        serviceTime: 'Mo. bis Fr. 8:00 - 18:00 Uhr',
        linkText: 'Kontaktformular',
        linkHref: 'https://www.kfw.de/KfW-Konzern/Formulare/KfW-Kontakt/',
        linkTarget: '_blank',
      },
    },

    {
      id: '9',
      module: 'FavouriteListModule',
      layout: simpleLayout('FavouriteListModule', 0, 3, 2, 1, false),
      props: {
        headline: '9 Favoriten',
        favorites: [
          {
            id: 1,
            linkHref: 'https://www.kfw.de/kfw.de.html',
            linkText: 'Längere Link Text damit man prüfen kann wie es gebrochen wird wenn es so lang ist',
            linkClass: 'multiple-link link ic-arrowRight',
            sortIndex: 0,
          },
          {
            id: 2,
            linkHref: 'https://www.kfw.de/kfw.de.html?1',
            linkText: 'Längere Link Text damit man prüfen kann wie es gebrochen wird wenn es so lang ist',
            linkClass: 'multiple-link link ic-arrowRight',
            sortIndex: 1,
          },
          {
            id: 3,
            linkHref: 'https://www.kfw.de/kfw.de.html?2',
            linkText: 'Längere Link Text damit man prüfen kann wie es gebrochen wird wenn es so lang ist',
            linkClass: 'multiple-link link ic-arrowRight',
            sortIndex: 2,
          },
          {
            id: 4,
            linkHref: 'https://www.kfw.de/kfw.de.html?3',
            linkText: 'Längere Link Text damit man prüfen kann wie es gebrochen wird wenn es so lang ist4',
            linkClass: 'multiple-link link ic-arrowRight',
            sortIndex: 3,
          },
          {
            id: 5,
            linkHref: 'https://www.kfw.de/kfw.de.html?4',
            linkText: 'Längere Link Text damit man prüfen kann wie es gebrochen wird wenn es so lang ist5',
            linkClass: 'multiple-link link ic-arrowRight',
            sortIndex: 4,
          },
          {
            id: 6,
            linkHref: 'https://www.kfw.de/kfw.de.html?5',
            linkText: 'Längere Link Text damit man prüfen kann wie es gebrochen wird wenn es so lang ist',
            linkClass: 'multiple-link link ic-arrowRight',
            sortIndex: 5,
          },
          {
            id: 7,
            linkHref: 'https://www.kfw.de/kfw.de.html?6',
            linkText: 'Längere Link Text damit man prüfen kann wie es gebrochen wird wenn es so lang ist7',
            linkClass: 'multiple-link link ic-arrowRight',
            sortIndex: 6,
          },
          {
            id: 8,
            linkHref: 'https://www.kfw.de/kfw.de.html?7',
            linkText: 'Sortindex = -1  damit man prüfen kann wie es gebrochen wird wenn es so lang ist',
            linkClass: 'multiple-link link ic-arrowRight',
            sortIndex: -1,
          },
        ],
      },
    },
    {
      id: '10',
      module: 'LinkedIconModule',
      layout: simpleLayout('LinkedIconModule', 2, 3, 1, 1, false),
      props: {
        headline: '10 Dokumentarchiv',
        linkText: 'Dokumentenarchiv Link',
        linkHref:
          'https://kfw-dev1.test-server.ag/partner/Technische-Seiten/Authentifizierung/index.jsp?vsp_referrer=%2fpartner%2fPartner-der-KfW%2fDokumentenarchiv%2fDokumentenarchiv-haupia.jsp',
        linkTarget: '_blank',
        locked: true,
      },
    },
    {
      id: '11',
      module: 'TextModule',
      layout: simpleLayout('TextModule', 3, 3, 1, 1, false),
      props: {
        headline: '11 Aktuelle News',
        headlineContentLevel: '3',
        headlineContent: 'Partner Bildungs-finanzierung',
        textContent:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."',
        linkText: 'Mehr erfahren',
        linkHref:
          'https://kfw-dev1.test-server.ag/partner/Technische-Seiten/Authentifizierung/index.jsp?vsp_referrer=%2fpartner%2fPartner-der-KfW%2fDokumentenarchiv%2fDokumentenarchiv-haupia.jsp',
        linkTarget: '_blank',
      },
    },
    {
      id: '12',
      module: 'TextModule',
      layout: simpleLayout('TextModule', 0, 4, 2, 1, false),
      props: {
        headline: '12 Aktuelle News Kachel 2x1',
        headlineContentLevel: '2',
        headlineContent:
          "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ",
        textContent:
          "t is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
        linkText: 'Mehr erfahren',
        linkHref:
          'https://kfw-dev1.test-server.ag/partner/Technische-Seiten/Authentifizierung/index.jsp?vsp_referrer=%2fpartner%2fPartner-der-KfW%2fDokumentenarchiv%2fDokumentenarchiv-haupia.jsp',
        linkTarget: '_blank',
      },
    },

    {
      id: '5952',
      module: 'ContactModule',
      layout: simpleLayout('ContactModule', 3, 0, 1, 1, false),
      tileRefId: '5952',
      props: {
        headline: '3 Kontakt',
        contactName: 'S. Macán',
        contactDescription: 'Referent Social Media / Medienmonitoring',
        contactPhone: '+49 69 7431-0',
        contactPhoneMobile: '+49 172 12345678',
        contactEmail: 's.macan@kfw.de',
      },
    },

    {
      id: '14',
      module: 'RegistrationModule',
      layout: simpleLayout('RegistrationModule', 0, 5, 3, 1, false),
      tileRefId: '',
      props: {
        headline: '13 Registrieren Sie sich jetzt als Partner. Es lohnt sich:',
        textContent:
          '<ul class="tile-list"><li>Lorem Ipsum1 - Ein ganz langer Text und der wird noch länger</li><li>Lorem Ipsum2</li><li>Lorem Ipsum3</li><li>Lorem Ipsum4</li></ul>',
      },
    },

    {
      id: '15',
      module: 'AppStoreModule',
      layout: simpleLayout('AppStoreModule', 0, 0, 1, 1, false),
      tileRefId: '',
      props: {
        headline: '14 AppStore',
      },
    },

    {
      id: '16',
      module: 'FormsModule',
      layout: simpleLayout('FormsModule', 0, 0, 2, 1, false),
      tileRefId: '',
      props: {
        headline: '15 FormsModule <strong>151, 152</strong>',
        searchUrl:
          'https://kfw-dev1.test-server.ag/d-archiv/do.haupia?query=*%3A*&page=1&rows=10&sortBy=relevance&sortOrder=desc&facet.filter.language=de&facet.filter.validity_documentarchive=%2201_true%22&dymFailover=true&groups=1&do_preset_filters=false',
      },
    },
  ],
};

export const mockTopics = [
  {
    id: '1',
    title: '2 Dokumentenarchiv',
    subItems: [],
    sort: 2,
  },
  {
    id: '2',
    title: '1 Bankdurchleitung',
    sort: 1,
    subItems: [
      {
        id: '2-1',
        title: 'BDO-Übersicht 2',
        sort: 2,
        subItems: [],
      },
      {
        id: '2-2',
        title: 'BDO-Webservice 1',
        sort: 1,
        subItems: [],
      },
    ],
  },
  {
    id: '3',
    title: 'Bankdurchleitung 2',
    sort: 3,
    subItems: [
      {
        id: '3-1',
        title: 'BDO-Übersicht 2',
        subItems: [],
      },
      {
        id: '3-2',
        title: 'BDO-Webservice 2',
        subItems: [],
      },
    ],
  },
  {
    id: '4',
    title: 'Dokumentenarchiv 3',
    sort: 4,
    subItems: [],
  },
  {
    id: '5',
    title: ' has single child Dokumentenarchiv 4',
    sort: 5,
    subItems: [
      {
        id: '5-1',
        title: 'Dokumentenarchiv 3 (should be alone witout accordion)',
        sort: 4,
        subItems: [],
      },
    ],
  },
] as ICheckItem[];

export const mockPrograms = [
  {
    id: 'program-151-sanieren',
    number: '151',
    title: '151 Energieeffizient Sanieren',
    tiles: [
      {
        id: '151-1',
        module: 'ProductModule',
        layout: null, // simpleLayout('m001', 0, 0, 1, 1, false),
        props: {
          headline: 'Kredit 151',
          creditId: '076-077B',
          creditType: 'Kredit',
          textContent: 'Altersgerecht Umbauen - Kredit',
          linkText: 'Zum Kredit',
          linkHref: '',
        },
        description: 'Lorem Ipsum über dieses Modul',
      },
      {
        id: '151-2',
        module: 'ProductModule',
        layout: null, // simpleLayout('m001', 0, 0, 1, 1, false),
        props: {
          headline: 'Zuschuss 151',
          creditType: 'Zuschuss',
          creditId: '420',
          textContent: 'Lorem Ipsum',
          linkText: 'Zum Zuschuss',
          linkHref: '',
        },
        description: 'Lorem Ipsum über dieses Modul',
      },
      {
        id: '151-3',
        module: 'LinkedIconModule',
        layout: null,
        props: {
          headline: 'Alle Kontakte',
          linkText: 'Zur Kontaktliste',
          linkHref: '',
          linkTarget: '',
          dataOverlayUrl: 'https://kfw-dev1.test-server.ag/inlandsfoerderung/Tools/Schnipsel/vc_overlay_1472.html',
          dataOverlaySize: 'large',
          dataIsAjax: true,
          dataOverlayBind: false,
        },
        description:
          'Lorem Ipsum über dieses Modul mit längerem Beschreibungstext, der über mehrere Zeilen läuft. Mal sehen, wie es wirkt!',
      },
    ],
  },

  {
    id: 'program-153-test',
    number: '153',
    title: '153 Energieeffizient Sanieren',
    tiles: [
      {
        id: '153-1',
        module: 'ProductModule',
        layout: null,
        props: {
          headline: 'Kredit 153',
          creditId: '153',
          creditType: 'Kredit',
          textContent: 'Test - Kredit',
          linkText: 'Zum Kredit',
          linkHref: '',
        },
        description: 'Lorem Ipsum über dieses Modul',
      },
      {
        id: '153-2',
        module: 'ProductModule',
        layout: null,
        props: {
          headline: 'Zuschuss 153',
          creditId: '153',
          creditType: 'Zuschuss',
          textContent: 'Test - Zuschuss',
          linkText: 'Zum Zuschuss',
          linkHref: '',
        },
        description: 'Lorem Ipsum über dieses Modul',
      },
      {
        id: '153-3',
        module: 'LinkedIconModule',
        layout: null,
        props: {
          headline: 'Alle Kontakte',
          linkText: 'Zur Kontaktliste',
          linkHref: '',
          linkTarget: '',
          dataOverlayUrl: 'https://kfw-dev1.test-server.ag/inlandsfoerderung/Tools/Schnipsel/vc_overlay_1472.html',
          dataOverlaySize: 'large',
          dataIsAjax: true,
          dataOverlayBind: false,
        },
        description:
          'Lorem Ipsum über dieses Modul mit längerem Beschreibungstext, der über mehrere Zeilen läuft. Mal sehen, wie es wirkt!',
      },
    ],
  },
] as IProgram[];

export const mockFormLinks: IForm[] = [
  {
    link: 'https://kfw-dev1.test-server.ag/partner/Dokumente/Archiv/Testdokument.pdf',
    title: ['KFWLINIE-1723x mit sehr langem Titel damit Umbrüche geprüft werden können'],
    title_short: ['Short title for KFWLINIE-1723x'],
    is_barrier_free: ['non-accessible'],
    media_type: ['pdf'],
    document_filesize: ['7 KB'],
  },
  {
    link: 'https://kfw-dev1.test-server.ag/partner/Dokumente/Archiv/Testdokument.pdf',
    title: ['KFWLINIE-1723 Test dokument 2'],
    is_barrier_free: ['accessible'],
    media_type: ['pdf'],
    document_filesize: ['17 KB'],
  },
  {
    link: 'https://kfw-dev1.test-server.ag/partner/Dokumente/Archiv/Testdokument.pdf',
    title: ['KFWLINIE-1723 mit sehr langem Titel damit Umbrüche geprüft werden können'],
    is_barrier_free: ['non-accessible'],
    media_type: ['pdf'],
    document_filesize: ['7 KB'],
  },
  {
    link: 'https://kfw-dev1.test-server.ag/partner/Dokumente/Archiv/Testdokument.pdf',
    title: ['KFWLINIE-1723 Test dokument 2'],
    is_barrier_free: ['accessible'],
    media_type: ['pdf'],
    document_filesize: ['17 KB'],
  },
  {
    link: 'https://kfw-dev1.test-server.ag/partner/Dokumente/Archiv/Testdokument.pdf',
    title: ['KFWLINIE-1723 Test dokument 3'],
    is_barrier_free: ['accessible'],
    media_type: ['pdf'],
    document_filesize: ['17 KB'],
  },
  {
    link: 'https://kfw-dev1.test-server.ag/partner/Dokumente/Archiv/Testdokument.pdf',
    title: ['KFWLINIE-1723 Test dokument 4'],
    is_barrier_free: ['accessible'],
    media_type: ['pdf'],
    document_filesize: ['17 KB'],
  },
  {
    link: 'https://kfw-dev1.test-server.ag/partner/Dokumente/Archiv/Testdokument.pdf',
    title: ['KFWLINIE-1723 Test dokument 5'],
    is_barrier_free: ['accessible'],
    media_type: ['pdf'],
    document_filesize: ['17 KB'],
  },
];

export const mockTranslations = {
  'cockpit.header.edit': 'Bearbeiten',
  'cockpit.header.new': 'Neu hinzufügen',
  'cockpit.removeModal.message': 'Möchten Sie diese Kachel wirklich entfernen?',
  'cockpit.removeModal.info': 'Sie können diese Kachel jederzeit über Ihre Cockpit-Einstellungen wieder anlegen.',
  'cockpit.removeModal.confirmText': 'Ja',
  'cockpit.removeModal.abortText': 'Nein',
  'cockpit.label.personalisation.text': 'Lorem ipsum...',
  'cockpit.contactmodule.emptyHint': 'Fügen Sie Ihren Kontakt ein: Klicken Sie auf <1>Bearbeiten</1> im Kachelmenü',
  'cockpit.contactmodule.emptyLinkText': 'Kontakt eintragen',
  'cockpit.contactmodule.error.email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'cockpit.contactmodule.error.tel': 'Bitte geben Sie die Telefonnummer im folgenden Format an: +49 69 123456789',
  'cockpit.contactmodule.error.mobil': 'Bitte geben Sie die Mobilnummer im folgenden Format an: +49 69 123456789',
  'cockpit.appstore.headline': 'Neues Modul zum Cockpit hinzufügen',
  'cockpit.appstore.intro': 'Lorem Ipsum',
  'cockpit.appstore.categoryHeadline': 'Kategorien',
  'cockpit.appstore.categoryAccordionOpener': 'Kategorien auswählen',
  'cockpit.appstore.resetFilters': 'Filter zurücksetzen',
  'cockpit.appstore.confirmFilters': 'Module anzeigen',
  'cockpit.appstore.searchHeadline': 'Modul Suchen',
  'cockpit.appstore.searchHint': 'Produktnummer oder Stichwort eingeben',
  'cockpit.appstore.searchResultCountSmall': 'Insgesamt <1>{{count}}</1> Module',
  'cockpit.appstore.searchResultHeadline': 'Module auswählen',
  'cockpit.appstore.searchResultCount': '- Ihre Suche ergab <1>{{count}}</1> Treffer',
  'cockpit.appstore.abortButton': 'Später festlegen',
  'cockpit.appstore.confirmButton': 'Zum Cockpit hinzufügen',
  'cockpit.appstore.contactTileTooltip': 'Sie können eine neue Kontakt-Kachel über das Drei-Punkte-Menu einer existierenden Kontakt-Kachel erstellen.',
  'cockpit.forms.openModal': 'Alle Formulare',
  'cockpit.forms.modalHeadline': 'Formularübersicht',
};
